import React from 'react';

const paths = {
  search: 'm21 21-4.4-4.4M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0',
  box: 'm12 3 9 5v9l-9 5-9-5V8l9-5Zm0 10 9-5M12 13 3 8m9 5v9M7.5 5.5l9 5',
  coin: 'M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM15 8h-4a2 2 0 0 0 0 4h2a2 2 0 0 1 0 4H9m3-10v2m0 8v2',
  clock: 'M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-8-5v5l3 2',
  arrow: 'm14 6-6 6 6 6',
  chevron: 'm7 10 5 5 5-5',
  contract: 'M8 3H5v18h14V3h-3M9 3h6v4H9V3Zm-1 9h8m-8 4h5',
  wallet: 'M20 8V5H5a2 2 0 0 0 0 4h16v11H5a2 2 0 0 1-2-2V7m18 6h-6v4h6m-3-2h.01',
  network: 'M12 8V3m0 13v5M8 12H3m13 0h5M7 7 4 4m13 13 3 3M7 17l-3 3M17 7l3-3M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
  menu: 'M4 6h16M4 12h16M4 18h16',
  close: 'm6 6 12 12M6 18 18 6',
  refresh: 'M20 10a8 8 0 0 0-14-5L3 8m0-5v5h5M4 14a8 8 0 0 0 14 5l3-3m-5 0h5v5',
  chart: 'M3 3v18h18M7 15l4-5 4 3 5-7',
  copy: 'M9 9h12v12H9V9ZM15 6V3H3v12h3',
  check: 'm5 12 4 4L19 6',
} as const;

export type IconName = keyof typeof paths;
export default function Icon({ name, size = 20 }: { name: IconName; size?: number }) {
  return (
    <svg
      width={ size }
      height={ size }
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={ paths[name] }/>
    </svg>
  );
}
